module.exports = __webpack_public_path__ + "img/purchase_preview_frame.e81d04c8.png";